import Design1 from './design-1';
import Design2 from './design-2';
import Design3 from './design-3';
import Design4 from './design-4';
import Design5 from './design-5';
import Design6 from './design-6';

import './index.css';
import useApplyUserDefinedListOverrides from "../../hooks/use-user-defined-list-sort";
import {WebsiteContext} from "../../index";
import {Fragment, useContext, useEffect, useState} from "react";
import axios from "axios";
import {filterItems} from "../../utils/utils";
import getPreviewBaseUrl from "../../utils/preview-domain";
import {Dialog, Transition} from "@headlessui/react";

const designs = [Design1, Design2, Design3, Design4, Design5, Design6];

export default function ListOfItemsBlock(props) {
    const context = useContext(WebsiteContext);
    const DesignBlock = designs[props.values?.design] ?? Design1;
    const source = props?.values?.source;
    const schemaUuid = props?.values?.item?.schema;
    const [items, setItems] = useState(() => filterItems(props?.values?.items || []));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({label: "", text: ""});
    const [imageWidth, setImageWidth] = useState(1184);
    const [state, setState] = useState(() => {
        if (props?.values?.source === "collection" && items.length === 0) return props?.values?.emptyState;
    });

    useEffect(() => {
        props?.values?.options?.listItemsMobileDisplay === 'scroll' && window.innerWidth < 1024
            ? setImageWidth(256)
            : window.innerWidth < context.breakpoint
                ? setImageWidth(Math.round(412 / (props?.values?.options?.columnsMobile ?? 1)))
                : setImageWidth(Math.round(1184 / (props?.values?.options?.columns ?? 1)))
    }, []);

    // Divice imageMax width by coloumns to return image width. 
    // Need to figure out if its mobile view, use column mobile if exists
    const handleOpenModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const values = useApplyUserDefinedListOverrides({
        ...props,
        items,
        itemsPositions: props?.values?.itemsPositions
    });

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();
        const emptyState = props?.values?.emptyState || 'placeholder';
        let active = true;

        if (context.builder && source === 'collection') {
            setItems([]);
            setState(emptyState);

            const previewBaseUrl = getPreviewBaseUrl(context?.website?.previewDomain);
            if (!previewBaseUrl || !schemaUuid) return () => {
                active = false;
                cancelToken.cancel();
            };

            // Resolve bindings, filters, size and sort through the same path as the preview.
            axios
                .post('/api/v2/website/schema', {...props.values}, {
                    headers: {"X-Preview-Domain": previewBaseUrl},
                    cancelToken: cancelToken.token,
                })
                .then(({data}) => {
                    if (!active) return;
                    const dataItems = data?.items || [];
                    if (dataItems.length > 0) {
                        setItems(filterItems(dataItems))
                        setState(null)
                    } else {
                        setItems([])
                        setState(emptyState)
                    }
                })
                .catch((err) => {
                    if (active && !axios.isCancel(err)) {
                        console.error("Failed to fetch schema data:", err)
                        setItems([])
                        setState(emptyState)
                    }
                })
        } else {
            const nextItems = filterItems(props?.values?.items || []);
            setItems(nextItems);
            setState(source === 'collection' && nextItems.length === 0 ? props?.values?.emptyState : null);
        }
        return () => {
            active = false;
            cancelToken.cancel();
        };
    }, [props?.values, context.builder, context.channel, context?.website?.previewDomain, source, schemaUuid]);

    return (
        <>
            <DesignBlock {...props} values={values} handleOpenModal={handleOpenModal} imageWidth={imageWidth}
                         state={state}/>
            <Transition appear show={isModalOpen} as={Fragment}
                        afterLeave={() => setModalContent({label: "", text: ""})}>
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/30"/>
                    </Transition.Child>
                    <div className="fixed inset-0 flex items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="relative">
                                <Dialog.Panel
                                    className="bg-white rounded-theme shadow-lg max-w-lg w-full mx-auto p-6 max-h-[75vh] mb-[calc(var(--site-nav-height)-16px)] overflow-y-auto">
                                    <Dialog.Title
                                        as="h5"
                                        className="text-center text-gray-900"
                                    >
                                        {modalContent.label}
                                    </Dialog.Title>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: modalContent.text,
                                        }}
                                        className="rich-text"
                                    />
                                </Dialog.Panel>
                                <button
                                    onClick={handleCloseModal}
                                    className="absolute -bottom-1 mt-4 mx-auto left-1/2 transform -translate-x-1/2 border-2 border-gray-300 bg-white rounded-full shadow-lg overflow-hidden"
                                >
                                    <svg
                                        className="h-8 w-8 stroke-gray-800 bg-gray-100 p-1"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
